// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2C1ak","title":"Header_title__3hk1i","side":"Header_side__3Xowd"};